import React from 'react';
import PropTypes from 'prop-types';
import { Marketplace } from '@quickenloans-ui-suite/components/marketplace';
import {
    useSourceIdCookie,
} from '../../../../useContentReplacers/contentReplacers/sourceid/useSourceIdCookie';
import constructSourceId from '../../../../useContentReplacers/contentReplacers/sourceid/constructSourceId';
import { parserBlockName, parserClassName, attribNames } from './Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const toMarketplace = () =>
{
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
    const Wrapper = ({
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs, 
        children = parserPropTypesDefaults.children 
    }) =>
    {
        if ( type !== 'tag' ) return null;
        if ( !name || name !== 'div' ) return null;
        if ( !attribs?.class || !attribs.class.includes(parserBlockName) ) return null;
        const placeholderElement = children?.find( (child) => child.attribs?.class.includes( parserClassName ));
        if ( !placeholderElement ) return null;
        const productType = placeholderElement.attribs[ attribNames.PRODUCT ];
        const variant = placeholderElement.attribs[ attribNames.VARIANT ];

        const { sourceid, location } = useSourceIdCookie();
        const contentSourceId = sourceid || constructSourceId( location, 'mkt' );
        return (
            <Marketplace 
                sourceId={contentSourceId} 
                environment={activeEnv} 
                defaultFilters={[
                    { key: "productType", value: productType }
                ]}
                variant={variant}
            />
        );
    }

    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}

export default toMarketplace;